let HomeSceneButton = require("clover/scene/component/homescene/HomeSceneButton")
let QQLiveConfig = require("activity/QQLive/QQLiveConfig")

/**
 * 腾讯视频指引图标
 */
let QQLiveIcon = xClass("QQLiveIcon", HomeSceneButton)

QQLiveIcon.prototype.ctor = function () {
    let iconName = "qqlive.ios.icon"
    if (window.mqq && window.OPEN_DATA.platform == 1){
        iconName = "qqlive.android.icon"
    }
    HomeSceneButton.prototype.ctor.call(this, 
        getText(iconName), QQLiveConfig.icon.image);
}


QQLiveIcon.prototype.customInit = function () {
    if (QQLiveConfig.icon.action != null) {
        let action = cc.CSLoader.createTimeline(QQLiveConfig.icon.action);
        let icon = this.imageNode;
        icon.runAction(action);
        action.gotoFrameAndPlay(0, true);
    }
    this.labelIcon = null;
    if (QQLiveConfig.icon.label != null) {
        this.labelIcon = cc.Sprite.createWithSpriteFrameName(QQLiveConfig.icon.label);
        this.labelIcon.setPosition(-90, 6);
        this.labelIcon.setScaleX(-1.0)
        let offsetx = -90;
        let offsety = 0;
        this.labelIcon.runAction(cc.RepeatForever.create(cc.Sequence.create(
            cc.MoveTo.create(0.2333, cc.p(17.25 + offsetx, offsety + 0)), 
            cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), 
            cc.MoveTo.create(0.2667, cc.p(17.25 + offsetx, offsety + 0)), 
            cc.MoveTo.create(0.2667, cc.p(0 + offsetx, offsety + 0)), 
            cc.MoveTo.create(0.3, cc.p(8.5 + offsetx, offsety + 0)), 
            cc.MoveTo.create(0.2333, cc.p(0 + offsetx, offsety + 0))
        )));
        this.addChild(this.labelIcon);
    }
}

QQLiveIcon.prototype.onCick = function () {
    let self = this;
    if (self.isBusy){
        return;
    } 

    self.isBusy = true; 
    setTimeOut(function () {
        self.isBusy = false
    }, 1)

    let resetBusy = function () {
        self.isBusy = false;
    }

    let panel = require("activity/QQLive/QQLivePanel");
    panel.preload().then(
            function(){
                panel.create(resetBusy).popup(true)
                }
        ).catch((e) => {Toast.make(quickGetErrorText(e, "打开腾讯视频指引面板失败"), null, resetBusy)});
}

module.exports = QQLiveIcon